module.exports = __webpack_public_path__ + "static/media/map-marker.28e4882e.svg";